import { InputNumber } from 'primereact/inputnumber'

import i18n from '../../utils/i18n'

export const DayFilterTemplate = (options: any) => {
  if (!options) return null

  return (
    <InputNumber
      value={options.value}
      onChange={e => options.filterCallback(e.value, options.index)}
      min={1}
      locale={i18n.language}
      placeholder={i18n.t('common.placeholders.searchDay')}
      suffix={i18n.t('common.suffix.days', { count: options.value })}
      showButtons
    />
  )
}
